/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Kpi,
    KpiFromJSON,
    KpiToJSON,
} from '../models/Kpi';

export interface DeleteKpisRequest {
    id: string;
}

export interface GetAllKpisRequest {
    id: string;
}

export interface UpdateKpiRequest {
    id: string;
    kpi: Array<Kpi>;
}

/**
 * 
 */
export class KPIApi extends runtime.BaseAPI {

    /**
     * Creates request options for deleteKpis without sending the request
     */
    async deleteKpisRequestOpts(requestParameters: DeleteKpisRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteKpis().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/kpi`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteKpisRaw(requestParameters: DeleteKpisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteKpisRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteKpis(requestParameters: DeleteKpisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteKpisRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllKpis without sending the request
     */
    async getAllKpisRequestOpts(requestParameters: GetAllKpisRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAllKpis().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/kpi`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllKpisRaw(requestParameters: GetAllKpisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Kpi>>> {
        const requestOptions = await this.getAllKpisRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KpiFromJSON));
    }

    /**
     */
    async getAllKpis(requestParameters: GetAllKpisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Kpi>> {
        const response = await this.getAllKpisRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateKpi without sending the request
     */
    async updateKpiRequestOpts(requestParameters: UpdateKpiRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateKpi().'
            );
        }

        if (requestParameters['kpi'] == null) {
            throw new runtime.RequiredError(
                'kpi',
                'Required parameter "kpi" was null or undefined when calling updateKpi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/kpi`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['kpi']!.map(KpiToJSON),
        };
    }

    /**
     */
    async updateKpiRaw(requestParameters: UpdateKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Kpi>>> {
        const requestOptions = await this.updateKpiRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KpiFromJSON));
    }

    /**
     */
    async updateKpi(requestParameters: UpdateKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Kpi>> {
        const response = await this.updateKpiRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
